import { render } from "./PaginationLoadMore.vue?vue&type=template&id=d179bbc4"
import script from "./PaginationLoadMore.vue?vue&type=script&lang=js"
export * from "./PaginationLoadMore.vue?vue&type=script&lang=js"

import exportComponent from "/Users/taylor/Documents/Code/laravel-nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"PaginationLoadMore.vue"]])

export default __exports__